// node_modules
import axios, { AxiosResponse } from "axios";
import { LoggingConstants } from "Constants";
// Helpers
import { AxiosHelperSingleton, PendoHelperSingleton } from "Helpers";
import { TMagDocumentDTO, TUsPatentDTO, TWebDocumentDTO } from "Types";
// 

export class ArticleController {
    public async getMagArticleAsync(id: number): Promise<TMagDocumentDTO> {
        // Log the retrieval of the mag document
        PendoHelperSingleton.trackEventWithProperties(`${LoggingConstants.DYNAMIC_DELIVERY}ArticlesGetMagDocument`, {
            magId: id
        });
        
        const response: AxiosResponse<TMagDocumentDTO> = await axios.get(`${AxiosHelperSingleton.getServerBaseURL()}api/articles/mag/${id}`);
        return response.data;
    }

    public async getMagArticlesAsync(ids: (number | string)[], caseId?: number): Promise<TMagDocumentDTO[]> {
        // Log the retrieval of the mag documents
        PendoHelperSingleton.trackEventWithProperties(`${LoggingConstants.DYNAMIC_DELIVERY}ArticlesGetMagDocuments`, {
            caseId: caseId
        });
        
        let idsQueryParam = "";
        ids.forEach((id: (string | number), index: number) => {
            idsQueryParam += `ids[]=${id}`;
            if (index + 1 < ids.length) idsQueryParam += "&";
        });
        if (caseId !== undefined) {
            idsQueryParam += `&caseId=${caseId}`;
        }
        const response: AxiosResponse<TMagDocumentDTO[]> = await axios.get(`${AxiosHelperSingleton.getServerBaseURL()}api/articles/science?${idsQueryParam}`);
        return response.data;
    }

    public async getUsPatentAsync(id: string): Promise<TUsPatentDTO> {
        // Log the retrieval of the patent
        PendoHelperSingleton.trackEventWithProperties(`${LoggingConstants.DYNAMIC_DELIVERY}ArticlesGetPatent`, {
            patentId: id
        });

        const response: AxiosResponse<TUsPatentDTO> = await axios.get(`${AxiosHelperSingleton.getServerBaseURL()}api/articles/patent/${id}`);
        return response.data;
    }

    public async getUsPatentsAsync(ids: (number | string)[], caseId?: number): Promise<TUsPatentDTO[]> {
        // Log the retrieval of the patents
        PendoHelperSingleton.trackEventWithProperties(`${LoggingConstants.DYNAMIC_DELIVERY}ArticlesGetPatents`, {
            caseId: caseId
        });

        let idsQueryParam = "";
        ids.forEach((id: (string | number), index: number) => {
            idsQueryParam += `ids[]=${id}`;
            if (index + 1 < ids.length) idsQueryParam += "&";
        });
        if (caseId !== undefined) {
            idsQueryParam += `&caseId=${caseId}`;
        }
        const response: AxiosResponse<TUsPatentDTO[]> = await axios.get(`${AxiosHelperSingleton.getServerBaseURL()}api/articles/patents?${idsQueryParam}`);
        return response.data;
    }

    public async getWebPageAsync(id: string): Promise<TWebDocumentDTO> {
        // Log the retrieval of the web pages
        PendoHelperSingleton.trackEventWithProperties(`${LoggingConstants.DYNAMIC_DELIVERY}ArticlesGetWebpage`, {
            pageId: id
        });
        
        const response: AxiosResponse<TWebDocumentDTO> = await axios.get(`${AxiosHelperSingleton.getServerBaseURL()}api/articles/web/${id}`);
        return response.data;
    }
}

export const ArticleControllerSingleton = new ArticleController();